const eventPreffixName = 'StoneWidget';

export const toggleVisibility = `${eventPreffixName}.toggleVisibility`;
export const setWidgetVisible = `${eventPreffixName}.setWidgetVisible`;

export const openWidget = `${eventPreffixName}.openWidget`;
export const closeWidget = `${eventPreffixName}.closeWidget`;

const eventNames = {
  toggleVisibility,
  setWidgetVisible,
  openWidget,
  closeWidget,
};

export default eventNames;
